import api from '../../../shared/services/apiClient';

export interface Dashboard {
  id: string;
  empresaId: string;
  sucursalId?: string | null;
  name: string;
  description?: string | null;
  aiPrompt?: string | null;
  layoutJson?: any;
  layout?: any; // Nuevo: para el layout del dashboard
  widgets?: any[]; // Nuevo: para los widgets generados
  autoWidgets?: any[]; // Nuevo: para compatibilidad con widgets IA legacy
  modelId?: string | null;
  dataSourceId?: string | null;
  hefestoModelId?: string | null;
  additionalSources?: string[];
  widgetsCount?: number;
  assignedTo?: string | null;
  companyId?: string | number;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  empresa?: {
    id: string;
    name: string;
  };
  dataSource?: {
    id: string;
    name: string;
    type: string;
  };
}

export interface DashboardCreateInput {
  name: string;
  description?: string;
  aiPrompt?: string;
  layoutJson?: any;
  modelId?: string;
  dataSourceId?: string;
  additionalSources?: string[];
  assignedTo?: string;
  widgets?: any[];
  widgetsMode?: 'merge' | 'replace';
}

export const getDashboards = async (): Promise<Dashboard[]> => {
  try {
    const res = await api.get('/dashboards');
    if (Array.isArray(res.data)) return res.data as Dashboard[];
    return (res.data?.dashboards || []) as Dashboard[];
  } catch (error: any) {
    console.error('Error loading dashboards:', error?.response?.status, error?.message);
    throw error;
  }
};

export const getDashboard = async (id: string): Promise<Dashboard | undefined> => {
  try {
    const res = await api.get(`/dashboards/${id}`);
    return res.data as Dashboard;
  } catch (error: any) {
    if (error?.response?.status === 404) {
      console.warn(`Dashboard ${id} not found (404)`);
      return undefined;
    }
    console.error('Error loading dashboard:', error?.message);
    throw error;
  }
};

export const createDashboard = async (data: DashboardCreateInput): Promise<Dashboard> => {
  const res = await api.post('/dashboards', data);
  return res.data as Dashboard;
};

export const updateDashboard = async (id: string, data: Partial<DashboardCreateInput>): Promise<Dashboard> => {
  const res = await api.put(`/dashboards/${id}`, data);
  return res.data as Dashboard;
};

export const deleteDashboard = async (id: string): Promise<boolean> => {
  const res = await api.delete(`/dashboards/${id}`);
  return res.status === 204 || res.status === 200;
};

export const generateWidgets = async (id: string, aiPrompt?: string): Promise<{ dashboard: Dashboard; widgets: any[] }> => {
  const body = aiPrompt ? { aiPrompt } : {};
  const res = await api.post(`/dashboards/${id}/generate-widgets`, body);
  return res.data;
};

export default {
  getDashboards,
  getDashboard,
  createDashboard,
  updateDashboard,
  deleteDashboard,
  generateWidgets,
};
